import HrManualAssignment from "./HrManualAssignment";
export default HrManualAssignment;